var chunkToChildrenMap = {
	"1067": [
		5450,
		6773,
		7488
	],
	"1911": [
		5450,
		6773,
		7488
	],
	"3839": [
		8673,
		2378,
		3192,
		2083,
		6077,
		7763,
		5453,
		1567,
		2128,
		1572,
		7420,
		9656,
		737,
		6535,
		5350,
		359,
		1620,
		8049,
		1313,
		4140
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}, () => {

}));